import {
    ENQUIRY_TYPE_SELECTOR_OPTIONS,
    type EnquiryType,
} from './enquiryConfig';
import { SelectableCard } from './SelectableCard';

interface Step0EnquiryTypeProps {
    value: EnquiryType | null;
    onSelect: (type: EnquiryType) => void;
}

export const Step0EnquiryType = ({
    value,
    onSelect,
}: Step0EnquiryTypeProps) => {
    return (
        <div className="flex flex-col gap-[1.375rem]">
            <h2 className="text-[1.3125rem] font-medium uppercase leading-[1.1] tracking-[-0.02em] text-[#161616]">
                what are you looking for?
            </h2>
            <ul className="flex flex-col gap-2">
                {ENQUIRY_TYPE_SELECTOR_OPTIONS.map((option) => (
                    <li key={option.value}>
                        <SelectableCard
                            title={option.title}
                            subtitle={option.subtitle}
                            selected={value === option.value}
                            onClick={() => onSelect(option.value)}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
};
